import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useUpdateData } from "hooks/useApiHooks";

const ChangeOrderStatus = ({ initialData, onSuccess, onError }) => {
    const CREATE_URL = '/booking';

    // Define available status options
    const statusOptions = [
        { value: 0, label: 'Waiting' },
        { value: 1, label: 'Pending' },
        { value: 2, label: 'Paid' },
        { value: 3, label: 'Done' },
        { value: 4, label: 'Cancel' },
    ];

    // State untuk menyimpan form data. Jika initialData tersedia, isi form untuk update
    const [formData, setFormData] = useState({
        status: initialData?.status,
        reason: initialData?.reason,
    });

    const { updateData: updateProduct, loading: updatingProduct } = useUpdateData(`${CREATE_URL}/${initialData?.id}/change-status`);

    // Gunakan hook untuk menangani perubahan form
    const handleChange = useFormChangeHandler(setFormData);

    // Gunakan hook untuk menangani pengiriman form
    const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
        updateProduct, // Gunakan updateProduct jika dalam mode update
        onSuccess,
        onError
    );

    useEffect(() => {
        // Jika data produk berubah (untuk update), isi ulang form data
        if (initialData) {
            setFormData({
                status: initialData?.status,
            });
        }
    }, [initialData]);

    return (
        <form onSubmit={(e) => handleSubmit(formData, e)} className="d-flex flex-column" style={{ height: '100%' }}>
            <div className="action-sheet-content flex-grow-1">
                {/* Input untuk status */}
                <div className="form-group mb-3">
                    <label htmlFor="status" className="form-label">Booking Status</label>
                    <select
                        className={clsx("form-select", formError?.status && 'is-invalid')}
                        id="status"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        disabled={isSubmitting}
                    >
                        <option value="" disabled>Pilih status</option>
                        {statusOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {formError?.status && <div className="invalid-feedback">{formError.status}</div>}
                </div>
                {formData.status === "4" && (
                    <div className="form-group mb-3">
                        <label htmlFor="reason" className="form-label">Reason</label>
                        <textarea
                            className={clsx("form-control", formError?.reason && 'is-invalid')}
                            id="reason"
                            name="reason"
                            value={formData.reason}
                            onChange={handleChange}
                            disabled={isSubmitting}
                        />
                        {formError?.reason && <div className="invalid-feedback">{formError.reason}</div>}
                    </div>
                )}
            </div>

            <div className="form-group mt-auto d-grid">
                <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
                    Change Status
                </button>
            </div>
        </form>
    );
};

export default ChangeOrderStatus;
